import { PiPackageLight } from "react-icons/pi";
import { setdata } from "../../../../../../../helpers/helpers";
import { fetchAllBundles } from "../../../../../../../services/ShipperServices/Packages/packages.services";
import { GridShell, GridTile, useGridData, weightSpec } from "../Products/GridParts";
import { BundleIcon, bundleWeight, packageCount } from "../Products/LibraryCells";

// The Bundles grid: one tile per bundle with its packages and their total
// weight, as the list shows them (page size, search, skeleton and footer from
// useGridData; the page size was a fixed 20). A click adds it as before.
export default function BundleGridView(props) {
  const { handlescrollpackage, setFilter, refresh } = props;
  const grid = useGridData({
    fetchPage: fetchAllBundles,
    refresh,
    setFilter,
    placeholder: "Filter Bundles",
  });

  const tileSpecs = (data) => [
    {
      key: "packages",
      icon: <PiPackageLight aria-hidden="true" />,
      label: "Packages",
      value: String(packageCount(data)),
    },
    weightSpec(bundleWeight(data)),
  ];

  return (
    <GridShell grid={grid} emptyText="No Bundles to display!">
      {grid.items.map((data, index) => (
        <GridTile
          key={data?.id ?? index}
          name={setdata(() => data.name, false, "")}
          photo={data?.file}
          icon={<BundleIcon />}
          specs={tileSpecs(data)}
          onClick={() => handlescrollpackage(data)}
        />
      ))}
    </GridShell>
  );
}
